import { Company } from './company';
import { Location } from './location';

export class UserLogInDetail {
    userId : string;
    userName : string;
    userEmail : String;
    company : Company;
    location : Location;
    parentLocationName:string;
    parentLocRefNo:number;
}
